/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */


/*@ngInject*/
export default function AddGatewayGroupController($scope, $mdDialog, $state, $stateParams, $document, $q, types, gatewayGroupService, entityTableConfiguration) {

    var vm = this;

    vm.$onInit = function () {
        vm.entityTableConfiguration = entityTableConfiguration;

        vm.entity = {};

        vm.entityType = vm.entityTableConfiguration.entityType;
        vm.translations = types.entityTypeTranslations[vm.entityType];

        vm.add = add;
        vm.cancel = cancel;
    };

    function cancel() {
        $mdDialog.cancel();
    }

    function add() {
        switch (vm.entityTableConfiguration.scope) {
            case types.scope.customer:
                if ($stateParams.customerId) {
                    vm.entity.customerId = {
                        entityType: types.entityType.customer,
                        id: $stateParams.customerId
                    };
                }
                break;
        }
        gatewayGroupService.saveGatewayGroup(vm.entity).then(function success(entity) {
            vm.entity = entity;
            $scope.theForm.$setPristine();
            $mdDialog.hide();
        });
    }

}


// WEBPACK FOOTER //
// ./src/app/gateway-group/add-gateway-group.controller.js